import { UI, HStack } from '@genial/components';
import React from 'react';

interface SubscriptionSolicitationHeaderProps {
  title: string;
  onClose: () => void;
}

export const SubscriptionSolicitationHeader: React.FC<SubscriptionSolicitationHeaderProps> = ({
  title,
  onClose,
}) => {
  return (
    <HStack space="inline.nano" alignItems="center" py="stack.nano">
      <UI.IconButton
        onPress={onClose}
        icon="ArrowLeft"
        iconSize="xs"
        testId="back"
        iconColor="neutral.black"
        p={0}
      />

      <UI.Text variant="semibold" color="neutral.black">
        {title}
      </UI.Text>
    </HStack>
  );
};
